import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Drawer from '@material-ui/core/Drawer';

import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import withUser from '../utils/withUser';
import * as CONSTANTS from '../constants';
import isPermissionSet from '../utils/isPermissionSet';

const linksMainMenu = [
  {
    to: '/companies',
    text: 'Unternehmen',
    materialIcon: 'domain'
  },
  {
    to: '/projects',
    text: 'Aufträge',
    materialIcon: 'question_answer'
  },
  { to: '/candidates', text: 'Kandidaten', materialIcon: 'group' },
  {
    to: '/intranet',
    text: 'Intranet',
    materialIcon: 'description',
    hide: !CONSTANTS.isPersonalTotal && !CONSTANTS.isSenator
  }
];
const linksReminders = [
  {
    to: '/reminders/candidates',
    text: 'Kandidaten',
    materialIcon: 'group'
  },
  {
    to: '/reminders/companies',
    text: 'Unternehmen',
    materialIcon: 'domain'
  }
];
const linksGeneralMenu = [
  {
    to: '/notifications',
    text: 'Benachrichtigungen',
    materialIcon: 'notifications'
  },
  {
    to: '/markLists',
    text: 'Merklisten',
    materialIcon: 'list'
  },
  {
    to: '/offers',
    text: 'Offerten',
    materialIcon: 'work_outline',
    hide: !CONSTANTS.isLienert
  },
  {
    to: '/search',
    text: 'Semantische Suche',
    materialIcon: 'search'
  }
];
const linksAdminMenu = [
  {
    to: '/incomingCandidates',
    text: 'Eingehende Kandidaten',
    materialIcon: 'group_add',
    isAdminLink: true,
    additionalPermission: 'incomingCandidate'
  },
  {
    to: '/applicantUser',
    text: 'Kandidatenprofile',
    materialIcon: 'group_add',
    isAdminLink: true,
    hide: !CONSTANTS.isLienert
  },
  {
    to: '/incomingMatchingProfiles',
    text: 'Matching Eingang',
    materialIcon: 'people',
    isAdminLink: true,
    hide: !CONSTANTS.isLienert
  },
  {
    to: '/settings',
    text: 'Einstellungen',
    materialIcon: 'supervisor_account',
    isAdminLink: false
  }
];
const linksBottomMenu = [
  {
    to: '/imprint',
    text: 'Impressum',
    materialIcon: 'info'
  },
  {
    to: '/privacy',
    text: 'Datenschutz',
    materialIcon: 'info'
  }
];
class MainMenuDrawer extends React.Component {
  state = {
    remindersOpen: false
  };

  renderRemindersMenu() {
    const excludeFromMenu = typeof CONSTANTS.excludeMenu[CONSTANTS.partner] !== 'undefined' ? CONSTANTS.excludeMenu[CONSTANTS.partner] : [];

    return (
      <>
        <ListItem button color="inherit" onClick={() => this.setState(prevState => ({ remindersOpen: !prevState.remindersOpen }))}>
          <ListItemIcon>
            <i className="material-icons">alarm</i>
          </ListItemIcon>
          <ListItemText primary="Wiedervorlagen" />
          <i className="material-icons">{this.state.remindersOpen ? 'expand_less' : 'expand_more'}</i>
        </ListItem>
        <Collapse in={this.state.remindersOpen} timeout="auto" unmountOnExit>
          <List disablePadding>
            {linksReminders
              .filter(link => !link.hide && !excludeFromMenu.includes(link.to))
              .map(link => (
                <ListItem
                  key={link.text}
                  button
                  component={Link}
                  to={link.to}
                  color="inherit"
                  style={{ paddingLeft: 32 }}
                  onClick={() => {
                    this.props.liftUpStateToApp({
                      mainMenuOpen: false
                    });
                    this.setState({ remindersOpen: false });
                  }}
                >
                  <ListItemIcon>
                    <i className="material-icons">{link.materialIcon}</i>
                  </ListItemIcon>
                  <ListItemText primary={link.text} />
                </ListItem>
              ))}
          </List>
        </Collapse>
      </>
    );
  }

  renderMainMenuLinks(menuArray) {
    const array = [];
    const excludeFromMenu = typeof CONSTANTS.excludeMenu[CONSTANTS.partner] !== 'undefined' ? CONSTANTS.excludeMenu[CONSTANTS.partner] : [];

    menuArray.forEach(link => {
      if (
        (!link.showFor || link.showFor.includes(this.props.user.id)) &&
        !link.hide &&
        (!link.isAdminLink || isPermissionSet(this.props.user, link.additionalPermission)) &&
        !excludeFromMenu.includes(link.to)
      )
        array.push(
          <ListItem
            key={link.text}
            button
            component={Link}
            to={link.to}
            color="inherit"
            onClick={() =>
              this.props.liftUpStateToApp({
                mainMenuOpen: false
              })
            }
          >
            <ListItemIcon>
              <i className="material-icons">{link.materialIcon}</i>
            </ListItemIcon>
            <ListItemText primary={link.text} />
          </ListItem>
        );
    });
    return array;
  }

  render() {
    return (
      <div>
        <Drawer open={this.props.open} onClose={() => this.props.liftUpStateToApp({ mainMenuOpen: false })}>
          <List>{this.renderMainMenuLinks(linksMainMenu)}</List>
          <Divider />
          <List>
            {this.renderRemindersMenu()}
            {this.renderMainMenuLinks(linksGeneralMenu)}
          </List>
          <Divider />

          <List>{this.renderMainMenuLinks(linksAdminMenu)}</List>
          <Divider />

          <List>{this.renderMainMenuLinks(linksBottomMenu)}</List>
        </Drawer>
      </div>
    );
  }
}

MainMenuDrawer.propTypes = {
  liftUpStateToApp: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  // page: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired
};
export default withUser(MainMenuDrawer);
